import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import Heading from '@atlaskit/heading';
import WorkItemIcon from '@atlaskit/icon/core/work-item';
import WorkItemsIcon from '@atlaskit/icon/core/work-items';
import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { BasePreviewCard } from '../../../../common/ui/base-preview-card';

const messages = defineMessages({
	singleWorkItemPreviewHeaderTitle: {
		id: 'jiraCreateWithRovoPreviewCard.singleWorkItemPreviewHeaderTitle',
		defaultMessage: 'Create work item',
		description: 'The title of the single work item preview card for the Jira AIFC experience',
	},
	multiWorkItemPreviewHeaderTitle: {
		id: 'jiraCreateWithRovoPreviewCard.multiWorkItemPreviewHeaderTitle',
		defaultMessage: 'Create work items',
		description: 'Title for the multi work item preview card header in the Jira AIFC experience',
	},
});

export const FallbackPreviewCard = ({
	isSelected,
	showSingleWorkItemCard,
}: {
	isSelected: boolean;
	showSingleWorkItemCard: boolean;
}): React.JSX.Element => {
	return (
		<BasePreviewCard
			previewProductLogo={
				showSingleWorkItemCard ? (
					<WorkItemIcon
						color={token('color.icon.accent.blue')}
						label={
							FeatureGates.getExperimentValue(
								'jira-aifc-a11y-fixes-preview-card',
								'isEnabled',
								false,
								{
									fireExperimentExposure: false,
								},
							)
								? ''
								: 'Work item'
						}
					/>
				) : (
					<WorkItemsIcon
						color={token('color.icon.accent.blue')}
						label={
							FeatureGates.getExperimentValue(
								'jira-aifc-a11y-fixes-preview-card',
								'isEnabled',
								false,
								{
									fireExperimentExposure: false,
								},
							)
								? ''
								: 'Work items'
						}
					/>
				)
			}
			isLoading={true}
			isSelected={isSelected}
			previewHeaderTitle={
				FeatureGates.getExperimentValue('jira-aifc-a11y-fixes-preview-card', 'isEnabled', false, {
					fireExperimentExposure: false,
				}) ? (
					<Heading as="h3" size="xsmall">
						<FormattedMessage
							{...(showSingleWorkItemCard
								? messages.singleWorkItemPreviewHeaderTitle
								: messages.multiWorkItemPreviewHeaderTitle)}
						/>
					</Heading>
				) : (
					<Text size="medium" weight="bold">
						<FormattedMessage
							{...(showSingleWorkItemCard
								? messages.singleWorkItemPreviewHeaderTitle
								: messages.multiWorkItemPreviewHeaderTitle)}
						/>
					</Text>
				)
			}
		/>
	);
};
